module.exports = __webpack_public_path__ + "img/1006204.b729e46e.svg";